import { FC } from 'react';

import { Tag } from '@servicetitan/design-system';

import { AppVersionApprovalStatus } from '../../api/app.api';
import { AppScopesVersionViewModel } from '../models/app-scopes-version-view-model';

const colorByStatus: Record<AppVersionApprovalStatus, 'warning' | 'critical' | 'success'> = {
    [AppVersionApprovalStatus.NotStarted]: 'warning',
    [AppVersionApprovalStatus.Rejected]: 'critical',
    [AppVersionApprovalStatus.Approved]: 'success',
};

export interface AppVersionStatusTagProps {
    version: AppScopesVersionViewModel;
    subtle?: boolean;
    compact?: boolean;
}

export const AppVersionStatusTag: FC<AppVersionStatusTagProps> = ({ version, subtle, compact }) => (
    <Tag color={colorByStatus[version.approvalStatus]} subtle={subtle} compact={compact}>
        {version.statusLabel}
    </Tag>
);
AppVersionStatusTag.displayName = 'AppVersionStatusTag';
